/* 🤖 this file was generated by svg-to-ts */
export const mgcIconSectorFilled: {
  name: 'sector-filled';
  data: string;
} = {
  name: 'sector-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M4.44 3.094c-.616.182-1.069.608-1.324 1.246l-.096.24-.011 7.26c-.009 5.177.001 7.335.032 7.52a2.006 2.006 0 0 0 1.599 1.599c.185.031 2.343.041 7.52.032l7.26-.011.24-.096c.66-.263 1.11-.763 1.26-1.401.089-.375-.005-1.492-.222-2.643a16.723 16.723 0 0 0-1.486-4.416c-.373-.745-.564-1.073-1.075-1.844a16.686 16.686 0 0 0-4.717-4.717c-.771-.511-1.099-.702-1.844-1.075A16.986 16.986 0 0 0 6.14 3.139c-.693-.09-1.478-.11-1.7-.045"/></svg>`
};
